export const API_CHANGE_PASSWORD = '/api/users/restorepass';
export const API_SEND_PASSWORD_LINK = '/api/users/{id}/password/reset';
export const API_AUTH_LOGIN_PASS = '/api/users/auth';
export const API_GET_CURRENT_USER = '/api/users/current';
export const API_GET_MANAGER_LINKS = '/api/users/{id}/links';
export const API_USER_UPLOAD_AVATAR = '/api/users/{uid}/avatar';
export const API_SETTINGS_UPLOAD_IMAGE = '/api/assets/upload';
export const API_USERS_UPDATE = '/api/users/update';
export const API_DIALOGS_REASSIGN = '/api/conversations/reassign';
export const API_UPLOAD_FILE = '/api/assets/upload';
